import styled from 'styled-components';
import { Popover, Slider } from '@mui/material';
import { COLOR } from '@src/styles/color';

// Horizontal volume popover anchored to a track's gutter button:
// [ mute-toggle icon | slider | value% ]. Matches the timeline design.
export const StyledVolumePopover = styled(Popover)`
  /* Root ignores pointer events so the gutter button underneath stays hoverable
     while the popover is open; the paper re-enables them for the slider. */
  pointer-events: none;

  & .MuiPopover-paper {
    pointer-events: auto;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 4px;
    padding: 4px 12px 4px 4px;
    border-radius: 10px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    overflow: visible;
  }
`;

export const StyledMuteButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: ${COLOR.darkBlue};
  cursor: pointer;

  &:hover {
    background: ${COLOR.indigo[8]};
  }

  svg {
    font-size: 20px;
  }
`;

export const StyledSlider = styled(Slider)`
  && {
    width: 78px;
    height: 4px;
    padding: 10px 0;
    color: ${COLOR.darkBlue};
  }

  & .MuiSlider-rail {
    opacity: 1;
    color: ${COLOR.indigo[16]};
  }

  /* No thumb in the design — the navy filled track shows the level. MUI still
     sets the value from a click/drag anywhere on the rail. */
  & .MuiSlider-thumb {
    display: none;
  }
`;

export const StyledValue = styled.span`
  min-width: 34px;
  text-align: right;
  font-size: 13px;
  color: ${COLOR.darkGray};
`;
